module.exports = __webpack_public_path__ + "files/898633786ba8d0a3ff21bd09aa79ad9e.png";